import { Button, Stack, Typography } from '@mui/material';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { queryClient } from '@shared/queries';
import { useAddSnackbarMessage } from '@shared/useAddSnackBar';
import AccordionSection from '../AccordionSection';

const RefreshCacheSection = () => {
  const addSnackbarMessage = useAddSnackbarMessage();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefreshCache = async () => {
    setIsRefreshing(true);
    try {
      // Clear cached data held in memory by React Query.
      queryClient.clear();

      // Clear the PWA Cache Storage (offline / asset caches).
      if ('caches' in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map(key => caches.delete(key)));
      }

      // Unregister any service workers so a fresh one is installed on reload.
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(registration => registration.unregister()));
      }

      addSnackbarMessage({
        text: 'Cache byla vymazána. Aplikace se nyní obnoví.',
        type: 'success',
      });

      // Hard reload to fetch the latest assets and data.
      setTimeout(() => window.location.reload(), 800);
    } catch {
      setIsRefreshing(false);
      addSnackbarMessage({
        text: 'Cache se nepodařilo vymazat. Zkuste to prosím znovu.',
        type: 'error',
      });
    }
  };

  return (
    <AccordionSection
      title={
        <FormattedMessage id="myProfile.refreshCache" defaultMessage="Obnovit cache aplikace" />
      }
    >
      <Stack spacing={2}>
        <Typography variant="body2" color="grey">
          <FormattedMessage
            id="myProfile.refreshCacheDescription"
            defaultMessage="Pokud se aplikace chová zastarale nebo se nezobrazují nejnovější data (např. na mobilu s nainstalovanou aplikací), vymažte uloženou cache a načtěte aplikaci znovu. Chyby však hlašte, aby byly obnoveny, toto je nouzové řešení."
          />
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<CachedOutlinedIcon />}
          onClick={handleRefreshCache}
          disabled={isRefreshing}
          sx={{ alignSelf: 'flex-start' }}
        >
          <FormattedMessage
            id="myProfile.refreshCacheButton"
            defaultMessage="Vymazat cache a obnovit"
          />
        </Button>
      </Stack>
    </AccordionSection>
  );
};

export default RefreshCacheSection;
